import { Tag } from 'lucide-react'
import { useState } from 'react'
import api from 'services/api'
import { toast } from 'react-toastify'

interface CartItem {
  product?: {
    current_price?: number
  }
  quantity?: number
  product_id?: number
}

interface CouponSectionProps {
  itens: CartItem[]
  isUpdating?: boolean
  blocked?: boolean
  onApplyCoupon: (coupon: any, itens: CartItem[], shippingDiscount?: number) => void
  onRemoveCoupon: () => void
  coupon: any
  onCheckout?: () => void
  onContinueShopping?: () => void
}

export function CouponSection({
  onCheckout,
  onContinueShopping,
  isUpdating = false,
  blocked = false,
  onApplyCoupon,
  onRemoveCoupon,
  coupon,
  itens
}: CouponSectionProps) {
  const [inputCoupon, setInputCoupon] = useState('')
  const [validating, setValidating] = useState(false)

  const handleApplyCoupon = async () => {
    if (!inputCoupon || !inputCoupon.trim()) {
      toast.error('Digite um cupom válido')
      return
    }

    setValidating(true)
    try {
      const payload = {
        coupon: {
          name: inputCoupon.trim()
        },
        items: itens.map((item: any) => ({
          product_id: item?.product_id,
          quantity: item?.quantity,
          ...item
        }))
      }

      const { data } = await api.post(`/coupon_public/valid-items`, payload)

      if (data?.sucess || data?.success) {
        // Backend reprova o cupom quando o desconto progressivo do carrinho é melhor (comparação por total)
        if (data?.applied === false || data?.winner === 'progressive') {
          toast.error(data?.message || 'Seu carrinho já possui um desconto melhor (progressivo)')
          return
        }

        const itemsToSend = data?.items || itens
        const shippingDiscount = data?.shippingDiscount || 0

        await onApplyCoupon(data?.coupon, itemsToSend, shippingDiscount)
        setInputCoupon('')
      } else {
        toast.error('Cupom inválido')
      }
    } catch (error: any) {
      console.error('Erro ao validar cupom:', error)
      const errorMessage = error?.response?.data?.message || 'Cupom inválido'
      toast.error(errorMessage)
    } finally {
      setValidating(false)
    }
  }

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      handleApplyCoupon()
    }
  }

  return (
    <div className="space-y-3">
      {!coupon ? (
        <div className="relative">
          <Tag className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder="Insira o Cupom:"
            className="w-[calc(100%-90px)] rounded-md border-0 bg-[#EDECE7] py-2 pl-10 pr-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#6B7B3C] focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
            value={inputCoupon}
            onChange={(e) => setInputCoupon(e.target.value)}
            onKeyPress={handleKeyPress}
            disabled={isUpdating || validating}
          />
          <div className="absolute right-0 top-1/2 -translate-y-1/2">
            <button
              className="rounded-md border-none bg-primary-700 px-3 py-2 text-sm text-white hover:bg-primary-800 disabled:cursor-not-allowed disabled:bg-gray-400"
              onClick={handleApplyCoupon}
              disabled={isUpdating || validating || !inputCoupon.trim()}>
              {validating ? 'Validando...' : 'Aplicar'}
            </button>
          </div>
        </div>
      ) : (
        <div className="relative">
          <Tag className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder="Insira o Cupom:"
            className="w-[calc(100%-90px)] rounded-md border-0 bg-[#EDECE7] py-2 pl-10 pr-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#6B7B3C] focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
            value={coupon.name}
            disabled
            onChange={() => {}}
          />
          <div className="absolute right-0 top-1/2 -translate-y-1/2">
            <button
              className="rounded-md border-none bg-primary-700 px-3 py-2 text-sm text-white hover:bg-primary-800 disabled:cursor-not-allowed disabled:bg-gray-400"
              onClick={() => onRemoveCoupon()}
              disabled={isUpdating}>
              Remover
            </button>
          </div>
        </div>
      )}
      {onCheckout && (
        <button
          onClick={onCheckout}
          disabled={isUpdating || blocked}
          style={{ outline: 'none' }}
          className="h-[44px] w-full rounded border-0 bg-[#6B7B3C] px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-[#5A6A2B] focus:outline-none focus:ring-2 focus:ring-[#6B7B3C] focus:ring-offset-2 disabled:cursor-not-allowed disabled:bg-gray-400 sm:h-[40px] sm:px-16 sm:text-base">
          {isUpdating ? 'Atualizando...' : 'Ir para pagamento'}
        </button>
      )}
    </div>
  )
}
